var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppstoreLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17466_4382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.256 0H18.744C21.6469 0 24 2.35312 24 5.256V18.744C24 21.6469 21.6469 24 18.744 24H5.256C2.35312 24 0 21.6469 0 18.744V5.256C0 2.35312 2.35312 0 5.256 0Z",
    fill: "url(#paint0_linear_17466_4382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69133 17.4193L7.69358 17.42L6.87298 18.8413C6.57345 19.3601 5.91008 19.5378 5.39127 19.2383C4.87245 18.9388 4.6947 18.2754 4.99423 17.7566L5.59873 16.7096L5.65677 16.6091C5.76036 16.4602 6.01602 16.2031 6.52742 16.2515C6.52742 16.2515 7.73089 16.3821 7.81798 17.0076C7.81798 17.0076 7.8298 17.2134 7.69133 17.4193ZM19.3297 13.7893H16.7709C16.5966 13.7775 16.5206 13.7153 16.4906 13.6791L16.4887 13.6758L13.7496 8.9315L13.7461 8.93385L13.5818 8.69835C13.3126 8.2866 12.8851 9.3396 12.8851 9.3396C12.3746 10.513 12.9575 11.8469 13.1607 12.2502L16.9653 18.8398C17.2647 19.3586 17.9281 19.5364 18.447 19.2368C18.9657 18.9373 19.1435 18.2739 18.8439 17.7551L17.8926 16.1073C17.8742 16.0674 17.8421 15.959 18.0372 15.9585H19.3297C19.9288 15.9585 20.4144 15.4729 20.4144 14.8738C20.4144 14.2748 19.9288 13.7893 19.3297 13.7893ZM14.3597 15.2637C14.3597 15.2637 14.4963 15.9584 13.9678 15.9584H4.50852C3.90945 15.9584 3.42383 15.4728 3.42383 14.8738C3.42383 14.2747 3.90945 13.7891 4.50852 13.7891H6.94039C7.33302 13.7664 7.42602 13.5397 7.42602 13.5397L7.42827 13.5408L10.6026 8.04256L10.6017 8.04238C10.6595 7.93616 10.6114 7.83575 10.603 7.81991L9.55461 6.00406C9.25508 5.48535 9.43283 4.82188 9.95164 4.52244C10.4705 4.223 11.1338 4.40056 11.4334 4.91938L11.9195 5.76153L12.4049 4.92088C12.7044 4.40216 13.3678 4.22431 13.8866 4.52394C14.4054 4.82356 14.5832 5.48675 14.2836 6.00556L9.86633 13.6565C9.84702 13.7031 9.84111 13.7762 9.98483 13.7891H12.6252L12.6258 13.8148C12.6258 13.8148 14.1518 13.8386 14.3597 15.2637Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17466_4382",
    x1: -1,
    y1: -3,
    x2: 28,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A74E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17466_4382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreLogo);
export default __webpack_public_path__ + "static/media/appstore-logo.163bd2839918382f9098ed3eaf1ae0b7.svg";
export { ForwardRef as ReactComponent };